import {config as configTradeholding} from './src/Tradeholding.FrontEndJs/js/config.tradeholding.js';

/** You can import other configuration files which may overwrite the default tradeholding config files here
 * 
 *  if you do, export a merged config file from this file
 */
export default configTradeholding;